<app-page-header [back]="{label: pendingTaskOrigin.label, link: pendingTaskOrigin.link}" title="Tarefas Pendentes"></app-page-header>
<div class="spinner" *ngIf="isLoading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<app-pending-tasks-empty *ngIf="pendingTasks.length == 0 && isLoading == false"></app-pending-tasks-empty>
<app-pending-task-card *ngFor="let pendingTask of pendingTasks"
  [pendingTask]="pendingTask"
  (updateEvent)="update()"
  [pendingTaskOrigin]="pendingTaskOrigin.link">
</app-pending-task-card>